(function () {
  if (window.__nestExtendCartDrawerHold20260625) return;
  window.__nestExtendCartDrawerHold20260625 = true;

  var extendSelector = '#extend-offers-modal-iframe, #extend-learn-more-modal-iframe, iframe[id*="extend"][id*="modal"], iframe[id*="Extend"][id*="Modal"], iframe[src*="extend"], iframe[src*="helloextend"], [id*="extend"][role="dialog"], [id*="Extend"][role="dialog"], [class*="extend"][role="dialog"], [class*="Extend"][role="dialog"], [class*="extend"][class*="modal"], [class*="Extend"][class*="Modal"]';
  var cartSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, [data-cart-drawer], [data-cart-container]';
  var holdClass = 'nest-extend-cart-drawer-hold-active';

  var startedAt = performance.now();
  var timing = window.NestExtendCartHoldTiming = window.NestExtendCartHoldTiming || [];
  var extendVisible = false;
  var holdActive = false;
  var releaseTimer = null;
  var refreshTimer = null;
  var patchUpdateCartTimer = null;
  var activeCartMutations = 0;
  var lastCartMutationAt = 0;
  var lastExtendClosedAt = 0;
  var updateCartQueued = false;
  var originalUpdateCart = null;
  var pendingPossibleExtendLaunch = false;
  var possibleExtendStartedAt = 0;

  var settleAfterExtendCloseMs = 1800;
  var quietAfterCartMutationMs = 300;
  var maxSettleAfterCloseMs = 3500;
  var maxPossibleExtendWaitMs = 20000;
  var pollMs = 150;

  function elapsed() {
    return Math.round((performance.now() - startedAt) * 10) / 10;
  }

  function mark(name, detail) {
    timing.push({ t: elapsed(), name: name, detail: detail || '' });
  }

  function isVisible(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function hasVisibleExtendModal() {
    return Array.prototype.some.call(document.querySelectorAll(extendSelector), isVisible);
  }

  function isNoteOnlyCartUpdateUrl(url) {
    if (typeof url !== 'string') return false;
    return /\/cart\/update\.js(?:\?|$)/.test(url) && /[?&]note=/.test(url);
  }

  function isCartMutationUrl(url) {
    if (typeof url !== 'string') return false;
    if (isNoteOnlyCartUpdateUrl(url)) return false;
    return /\/cart\/(add|change|update)\.js/.test(url);
  }

  function inExtendSettleWindow() {
    return !!lastExtendClosedAt && performance.now() - lastExtendClosedAt < maxSettleAfterCloseMs;
  }

  function shouldQueueUpdateCart() {
    return holdActive || extendVisible || inExtendSettleWindow() || pendingPossibleExtendLaunch;
  }

  function callOriginalUpdateCart() {
    var fn = originalUpdateCart || window.UpdateCart;
    if (typeof fn !== 'function') {
      mark('refresh cart skipped', 'UpdateCart unavailable');
      return;
    }

    mark('refresh cart after passive hold');
    return fn.call(window);
  }

  function patchUpdateCart() {
    if (patchUpdateCartTimer) window.clearTimeout(patchUpdateCartTimer);

    if (typeof window.UpdateCart !== 'function') {
      patchUpdateCartTimer = window.setTimeout(patchUpdateCart, 100);
      return;
    }

    if (window.UpdateCart.__nestExtendPassiveUpdateCartQueue20260702) return;

    originalUpdateCart = window.UpdateCart;

    window.UpdateCart = function () {
      if (shouldQueueUpdateCart()) {
        updateCartQueued = true;
        mark('UpdateCart queued during Extend hold', holdActive ? 'hold active' : 'settle window');
        scheduleReleaseCheck();
        return;
      }

      return originalUpdateCart.apply(this, arguments);
    };

    window.UpdateCart.__nestExtendPassiveUpdateCartQueue20260702 = true;
    mark('UpdateCart passive queue installed');
  }

  function installStyle() {
    if (document.getElementById('nest-extend-cart-drawer-hold-style-20260625')) return;

    var style = document.createElement('style');
    style.id = 'nest-extend-cart-drawer-hold-style-20260625';
    style.textContent = [
      'html.' + holdClass + ' ' + cartSelector.split(', ').join(',\nhtml.' + holdClass + ' ') + ' {',
      '  display: none !important;',
      '  opacity: 0 !important;',
      '  visibility: hidden !important;',
      '  pointer-events: none !important;',
      '}',
      'html.' + holdClass + ' .seo-cart-page-overlay {',
      '  display: none !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}',
      'html.' + holdClass + ' body.seo-cart-overlay-active .seo-cart-page-overlay {',
      '  display: none !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');

    (document.head || document.documentElement).appendChild(style);
  }

  function startVisualHold(reason) {
    installStyle();

    if (!holdActive) {
      holdActive = true;
      document.documentElement.classList.add(holdClass);
      mark('visual hold started', reason);
    } else {
      mark('visual hold continued', reason);
    }

    scheduleReleaseCheck();
  }

  function refreshCartOnce() {
    updateCartQueued = false;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(callOriginalUpdateCart, 60);
  }

  function endVisualHold(reason) {
    if (!holdActive) return;

    holdActive = false;
    pendingPossibleExtendLaunch = false;
    refreshCartOnce();

    window.setTimeout(function () {
      document.documentElement.classList.remove(holdClass);
      mark('visual hold released', reason);
    }, 520);
  }

  function scheduleReleaseCheck() {
    window.clearTimeout(releaseTimer);
    releaseTimer = window.setTimeout(checkRelease, 90);
  }

  function checkRelease() {
    if (!holdActive) return;

    var now = performance.now();

    if (extendVisible) {
      scheduleReleaseCheck();
      return;
    }

    if (pendingPossibleExtendLaunch && activeCartMutations === 0 && now - possibleExtendStartedAt < maxPossibleExtendWaitMs) {
      scheduleReleaseCheck();
      return;
    }

    if (pendingPossibleExtendLaunch && now - possibleExtendStartedAt >= maxPossibleExtendWaitMs) {
      pendingPossibleExtendLaunch = false;
      mark('possible Extend wait expired');
    }

    var sinceClose = now - lastExtendClosedAt;
    var sinceMutation = now - lastCartMutationAt;
    var quiet = activeCartMutations === 0 && sinceMutation >= quietAfterCartMutationMs;

    if (quiet && sinceClose >= settleAfterExtendCloseMs) {
      endVisualHold(updateCartQueued ? 'queued UpdateCart released after Extend settle' : 'Extend closed and cart quiet');
      return;
    }

    if (sinceClose >= maxSettleAfterCloseMs && activeCartMutations === 0) {
      endVisualHold('max passive wait reached');
      return;
    }

    scheduleReleaseCheck();
  }

  function observeExtendState() {
    var visible = hasVisibleExtendModal();

    if (visible && !extendVisible) {
      extendVisible = true;
      pendingPossibleExtendLaunch = false;
      startVisualHold('Extend modal visible');
    }

    if (!visible && extendVisible) {
      extendVisible = false;
      pendingPossibleExtendLaunch = false;
      lastExtendClosedAt = performance.now();
      startVisualHold('Extend modal closed, settling');
    }
  }

  function beginCartMutation(url) {
    activeCartMutations += 1;
    pendingPossibleExtendLaunch = false;
    lastCartMutationAt = performance.now();

    if (!extendVisible && inExtendSettleWindow()) {
      startVisualHold('cart mutation during Extend settle');
    }

    mark('cart mutation observed', activeCartMutations + ' ' + url);
  }

  function finishCartMutation(url) {
    activeCartMutations = Math.max(0, activeCartMutations - 1);
    lastCartMutationAt = performance.now();
    mark('cart mutation finished', activeCartMutations + ' ' + url);

    if (holdActive) scheduleReleaseCheck();
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestExtendPassivePatched20260625) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      var tracked = isCartMutationUrl(url);

      if (tracked) beginCartMutation(url);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (tracked) finishCartMutation(url);
        return response;
      }).catch(function (error) {
        if (tracked) finishCartMutation(url);
        throw error;
      });
    };

    window.fetch.__nestExtendPassivePatched20260625 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestExtendPassivePatched20260625) return;

    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__nestExtendPassiveUrl20260625 = url;
      return originalOpen.apply(this, arguments);
    };

    proto.send = function () {
      var xhr = this;
      var url = xhr.__nestExtendPassiveUrl20260625;
      var tracked = isCartMutationUrl(url);

      if (tracked) {
        beginCartMutation(url);
        xhr.addEventListener('loadend', function () {
          finishCartMutation(url);
        });
      }

      return originalSend.apply(this, arguments);
    };

    proto.__nestExtendPassivePatched20260625 = true;
  }

  function isMattressDecisionFlowPage() {
    var path = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
    return /\/products\/[^/]*(sparrow|starling|owl)[^/]*mattress/.test(path);
  }

  function productFormHasExtendOffer(target) {
    var form = target && target.closest ? target.closest('form[action="/cart/add"], form[data-product-form]') : null;
    if (!form) return false;
    return !!form.querySelector('#extend-offer, [id^="extend-offer-ada-"], [id^="extend-offer-"]');
  }

  function isAddToCartTarget(target) {
    return !!(target && target.closest && target.closest('[data-add-to-cart], button[name="add"], input[name="add"], .product-form__cart-submit'));
  }

  function preHoldPossibleExtendLaunch(event) {
    var target = event && event.target;
    if (!isMattressDecisionFlowPage()) return;
    if (!isAddToCartTarget(target) || !productFormHasExtendOffer(target)) return;
    pendingPossibleExtendLaunch = true;
    possibleExtendStartedAt = performance.now();
    lastExtendClosedAt = possibleExtendStartedAt;
    startVisualHold('possible Extend launch');
  }

  function bindPreHoldEvents() {
    document.addEventListener('pointerdown', preHoldPossibleExtendLaunch, true);
    document.addEventListener('mousedown', preHoldPossibleExtendLaunch, true);
    document.addEventListener('touchstart', preHoldPossibleExtendLaunch, true);
    document.addEventListener('click', preHoldPossibleExtendLaunch, true);
  }

  function init() {
    installStyle();
    patchFetch();
    patchXhr();
    patchUpdateCart();
    bindPreHoldEvents();
    observeExtendState();

    if (window.MutationObserver) {
      new MutationObserver(observeExtendState).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden', 'hidden']
      });
    }

    window.setInterval(observeExtendState, pollMs);
    mark('passive cart drawer suppression loaded');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
